import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { config } from 'config'

export default class Code extends React.Component {
  render () {
    return (
      <div className="page">
        <Helmet
          title={'Code • ' + config.siteTitle}
          meta={[
            {"name": "description", "content": "Chris Jennings's recent GitHub activity."},
            {"name": "keywords", "content": "about, ckj, sentry, github, disqus"},
          ]}
        />
        <h1>
          recent github activity
        </h1>
        <hr/>
        <p>Coming soon.</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./code.js